module.exports = __webpack_public_path__ + "static/media/88261644482712theroyal.c2709edb.png";